/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_AdminInputs */

const cs_nav_section_admin = /** @type {(inputs: Nav_Section_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Správa`)
};

const en_nav_section_admin = /** @type {(inputs: Nav_Section_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin`)
};

/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Nav_Section_AdminInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_admin = /** @type {((inputs?: Nav_Section_AdminInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_AdminInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_admin(inputs)
	return cs_nav_section_admin(inputs)
});